var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.SAAS)?_c('saas-login',{ref:"login"}):_c('seller-login',{ref:"login"})
}
var staticRenderFns = []

export { render, staticRenderFns }